export enum RegistrationAlertMessages {
  SUCCESS_DROPPED_TEXT = 'You have dropped',
  FAILED_DROPPED_TEXT = 'We were not able to drop',
  SUCCESS_REGISTERED_TEXT = 'You have registered for',
  FAILED_REGISTERED_TEXT = 'We were not able to register',
  PAY_TUITION_TEXT = 'Be sure to pay tuition once you have registered all your courses.',
  WAITLIST_SUCCESS_TEXT = 'You have waitlisted',
  WAITLIST_FAIL_TEXT = 'We are unable to waitlist ',
  WAITLIST_REMOVE_SUCCESS_TEXT = 'You are removed from the waitlist for',
  WAITLIST_REMOVE_FAIL_TEXT = 'We are unable to remove you from the waitlist for',
  SUCCESSFUL_SCHEDULED_TEXT = 'You have scheduled',
  SUCCESSFUL_UNSCHEDULED_TEXT = 'You have unscheduled',
  ADDITIONAL_SECTIONS_ARE_REQUIRED_TEXT = 'Additional sections are offered',
  UNSCHEDULE_SECTION_FAIL_TEXT = 'We are unable to unschedule',
  CO_REQUISITES_REQUIRED_TEXT = 'Remember to schedule the required co-requisites(s) for ',
  PRE_REQUISITES_REQUIRED_TEXT = 'Remember to schedule the required prerequisites(s) for ',
  ENFORCED_CO_REQUISITES_DROP_REMINDER_TEXT = 'are corequisites and must be dropped together.',
  SUCCESSFUL_ADDED_COREQ_TEXT = 'You have added',
  AUTO_WAITLIST_REGISTERED_TEXT = ' had a seat available and we successfully registered this course.',
  AUTO_WAITLIST_WAITLISTED_TEXT = ' was full. We added you to the waitlist.',
  AUTO_REGISTER_WAITLISTED_TEXT = 'You will be automatically registered when a seat becomes available.',
  PENDING_AUTO_WAITLIST_REGISTERED_TEXT = '<p class="text">Pending...</p> We will automatically attempt to waitlist any classes that are full',
  PENDING_AUTO_WAITLIST_WAITLISTED_TEXT = '<p class="text">Pending...</p> We will automatically attempt to register any classes that have seats available',
  PENDING_DEFAULT_TEXT = 'Pending',
  PENDING_SWAP_TEXT = 'Swap pending.  This may take a moment...',
  PENDING_REFRESH_SEATS_TEXT = 'Refreshing seat availability',
  SUCCESSFUL_REFRESH_SEATS_TEXT = 'Seat availability updated',
  FAILED_REFRESH_SEATS_TEXT = 'Refreshing seat availability failed',
  PENDING_REFRESH_SECTION_AVAILABILITY_TEXT = 'Updating section availability',
  SUCCESSFUL_REFRESH_SECTION_AVAILABILITY_TEXT = 'Section availability updated!'
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/types/registration_alert_messages.ts